import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Col, Form, Label, Row, Spinner } from 'reactstrap';
import { expenseFormData, expenseFormErrors } from '../../../FormData';
import { Btn, H3, H4, H6 } from '../../../../../../AbstractElements';
import DollarInput from '../../../../../common/DollarInput';
import Dropdown from '../../../../../common/DropDown';
import { useMutationRequestQuery } from '../../../../../../Hooks/useMutationRequestQuery';
import { sendFactFindPdfFileService, updateClientExpensesService } from '../../../../../../Services/PublicPageServices';
import { useDispatch } from 'react-redux';
import { setFormStatus } from '../../../../../../ReduxToolkit/Reducers/FromStatusSlice';
import { setFormsData } from '../../../../../../ReduxToolkit/Reducers/FormDataSlice';
import { updateFormData } from '../../../../../../ReduxToolkit/Reducers/FactFindDataSlice';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../ReduxToolkit/Store';
import { AssetsHTML, AssetsNonPropertyHTML, ClientOneHTML, ClientTwoHTML, DependentsHTML, ExpenseDetailsHTML, ExpenseDetailsHTML2, LiabilitiesHTML, VehicleAssetsHTML } from './FactFindPdf';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import DecimalInput from '../../../../../common/DecimalInput';
import { upsertClientMMPIncomeExpenseDetails } from '../../../../../../Services/MMPClientServices/IncomeAndExpenses';
const Expenses = ({ activeCallBack, clientFactFindData: DropdownData, clientId, setClientId }: any) => {
  const [formData, setFormData] = useState<any>(expenseFormData);
  const [formErrors, setFormErrors] = useState(expenseFormErrors);
  const factFind = useSelector((state: RootState) => state.factFind);
  const dispatch = useDispatch()
  const [file, setFile] = useState<any>(null)
  const [loading, setLoading] = useState<boolean>(false);
  // Validate expense fields
  const validateAmount = (value: string) => value.trim() !== "";
  const validateFrequency = (value: string) => value.trim() !== "";

  const { mutate: updateClientExpenses, isPending: isUpdateClientExpensesPending } = useMutationRequestQuery(
    'upsertClientMMPIncomeExpenseDetails',
    upsertClientMMPIncomeExpenseDetails as any,
    {
      onSuccess: (data: any) => {
        dispatch(setFormStatus({ id: '8', status: 8 }));
        // window.location.href = '/factfind-success';
      },
      onError: (error: any) => {
        toast.error("Failed to submit Expenses information");
        console.error(error);
      },
    }
  );

  const { mutate: sendFactFindPdf, isPending: isSendFactFindPdfPending } = useMutationRequestQuery(
    'sendFactFindPdfFileService',
    sendFactFindPdfFileService,
    {
      onSuccess: (data: any) => {
        window.location.href = '/factfind-success';
      },
      onError: (error: any) => {
        console.error(error);
      },
    }
  );

  useEffect(() => {
    dispatch(setFormsData({
      id: '8',
      formData: formData,
    }));
    dispatch(
      updateFormData({
        formName: "expenses",
        formData: formData,
      })
    );
  }, [formData])

  const generateFactFindPDF = async () => {
    setLoading(true)
    const doc = new jsPDF("p", "mm", "a4");
    const pageWidth = 210;
    const pageHeight = 297;

    const htmlSections = [
      { name: "Client One", html: ClientOneHTML(factFind.client1Details) },
      { name: "Client Two", html: ClientTwoHTML(factFind.client2Details) },
      { name: "Dependents", html: DependentsHTML(factFind.dependents) },
      { name: "Assets", html: AssetsHTML(factFind.assetsProperty) },
      { name: "Assets Non-Property", html: AssetsNonPropertyHTML(factFind.assetsNonProperty) },
      { name: "Vehicle Assets", html: VehicleAssetsHTML(factFind.assetsVehicles) },
      { name: "Liabilities", html: LiabilitiesHTML(factFind.liabilities) },
      { name: "Expense Details", html: ExpenseDetailsHTML(factFind.expenses) },
      { name: "", html: ExpenseDetailsHTML2(factFind.expenses) },
    ];

    for (let i = 0; i < htmlSections.length; i++) {
      const { name, html } = htmlSections[i];
      const container = document.createElement("div");

      // Move container off-screen
      container.style.width = "794px";
      container.style.position = "absolute";
      container.style.left = "-9999px";
      container.innerHTML = html;
      document.body.appendChild(container);

      try {
        const canvas = await html2canvas(container, { scale: 1.0 });
        const imgData = canvas.toDataURL("image/jpeg", 0.8);

        let imgWidth = pageWidth;
        let imgHeight = (canvas.height * imgWidth) / canvas.width;

        if (imgHeight > pageHeight) {
          imgHeight = pageHeight;
        }

        if (i !== 0) doc.addPage();
        doc.addImage(imgData, "JPEG", 0, 0, imgWidth, imgHeight);
      } catch (error) {
        console.error(`Error rendering section "${name}":`, error);
      } finally {
        document.body.removeChild(container);
      }
    }

    // Convert to Blob and store in state
    const pdfBlob = doc.output("blob");
    const pdfFile = new File([pdfBlob], "FactFind.pdf", { type: "application/pdf" });
    // doc.save("FactFind.pdf");
    setFile(pdfFile);
    setLoading(false)
    return pdfFile;
  };
  const prepareDataForApi = () => {
    const dataForApi = [] as any;

    Object.keys(clientFactFindData).forEach((parentCategory) => {
      clientFactFindData[parentCategory].forEach((categoryName: string) => {
        const formKey = `${categoryName}-amount`;

        if (formData[formKey] !== undefined) {
          const expense = {
            clientId: clientId,
            parentCategory,
            categoryName,
            amountValue: formData[`${categoryName}-amount`] || '0',
            frequencyValue: formData[`${categoryName}-frequency`] || '',
            annualAmountValue: formData[`${categoryName}-annual`] || '0',
            monthlyAmountValue: formData[`${categoryName}-monthly`] || '0',
            percentageOfTotalValue: formData[`${categoryName}-percentage`] || '0'
          };
          dataForApi.push(expense);
        }
      });
    });

    return dataForApi;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (clientId !== 0) {
      const dataForApi = prepareDataForApi();
      updateClientExpenses(dataForApi)
      const pdfFile: any = await generateFactFindPDF();
      if (pdfFile) {
        sendFactFindPdf({ To: "help@fintrack.com.au", PdfFile: pdfFile })
        // sendFactFindPdf({ To: "help@fintrack.com.au", PdfFile: pdfFile })
      }
    }
  };
  const handleValueChange = (name: string, value: string) => {
    const updatedFormData = {
      ...formData,
      [name]: value,
      [`${name.split('-')[0]}-annual`]: '0',
      [`${name.split('-')[0]}-monthly`]: '0',
      [`${name.split('-')[0]}-percentage`]: '0',
    };
    setFormData(updatedFormData);
  };


  const [clientFactFindData] = useState<any>({
    "Renting a Property": [
      "I am Renting A Property"
    ],
    "Child Care & Support": [
      "Child Care & Baby Sitting",
      "Child Maintenance & Support"
    ],
    "Education": [
      "Public School Costs",
      "Private School Costs",
      "Higher Education HECS/HELP"
    ],
    "Groceries": [
      "Food"
    ],
    "House you live in": [
      "Body Corporate",
      "Council Rates (if own property)",
      "Electricity",
      "Gas",
      "Repairs & Maintenance",
      "Sewer Rates",
      "Water usage"
    ],
    "Insurance": [
      "Building Insurance",
      "Contents Insurance",
      "Health Insurance",
      "Income Protection",
      "Life Insurance",
      "Vehicle Insurance"
    ],
    // "Investment Property": [
    //     "Building Insurance",
    //     "Body Corporate",
    //     "Council Rates",
    //     "Land Tax",
    //     "Repairs & Maintenance",
    //     "Running Costs",
    //     "Sewerage Rates"
    // ],
    "Medical Expenses": [
      "Dental & Optical",
      "Medical & Health",
      "Natural Therapists"
    ],
    // "Ongoing Rent": [
    //     "Board",
    //     "Rent"
    // ],
    "Personal Care": [
      "Clothing & Footwear",
      "Cosmetics",
      "Dry Cleaning",
      "Personal Care"
    ],
    "Recreational & Entertainment": [
      "Alcohol & Tobacco",
      "Cinema & Concerts",
      "Dining Out",
      "Gifts & Miscellaneous",
      "Gym & Sports",
      "Pets",
      "Subscriptions (non-streaming)",
      "Takeaway",
      "Travel & Holidays"
    ],
    "Telephone & Internet": [
      "Home & Mobile Phone",
      "Internet",
      "Pay TV & streaming"
    ],
    "Transport": [
      "Petrol",
      "Public Transport",
      "Taxi Ride / Uber",
      "Tolls & Parking",
      "Vehicle Registration",
      "Vehicle Repairs"
    ]
  });

  const splitDropdownValues = (dropdownValues: string) => {
    return dropdownValues ? dropdownValues.split(',').map(value => value.trim()) : [];
  };

  return (
    <>
      <div >

        <div className="table-responsive h-100 py-4">
          <section className='bg-white'>
            <div className="scrollable-table-container">
              <table className="scrollable-table" style={{ marginLeft: '1%', marginTop: '3%' }}>
                <Row className='g-3'>
                  <Col xs={6} className='mb-4 text-left'>
                    <H3 className='f-w-900 heading-color'>Expenses</H3>
                  </Col>

                  <Col xs={5} className="text-end  ">
                    <Btn color="primary" className='me-2' style={{ fontSize: '18px' }} onClick={() => activeCallBack(7)}>
                      Previous
                    </Btn>
                    <Button
                      type="button"
                      color="success"
                      onClick={handleSubmit}
                      disabled={loading || isSendFactFindPdfPending || isUpdateClientExpensesPending}
                      style={{ fontSize: '18px' }}
                    >
                      {loading || isSendFactFindPdfPending || isUpdateClientExpensesPending ? (
                        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                          <Spinner color="light" size="sm" />
                          <span>Loading . . .</span>
                        </div>
                      ) : (
                        "Send Fact Find"
                      )}

                    </Button>
                  </Col>
                </Row>
                <Row>
                  {/* Heading Row */}
                  <div className='d-flex'>
                    <Col className="responsive-col-expense" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                      <Label className="heading-color f-w-900 text-left">Expense</Label>
                    </Col>
                    <Col className="responsive-col-expense" xs={12} style={{ width: '13%', paddingInline: '2px' }}>
                      <Label className="heading-color f-w-900 text-left">Amount</Label>
                    </Col>
                    <Col className="responsive-col-expense" xs={12} style={{ width: '13%', paddingInline: '2px' }}>
                      <Label className="heading-color f-w-900 text-left">Frequency</Label>
                    </Col>
                    {/* <Col className="responsive-col-expense" xs={12} style={{ width: '9%', paddingInline: '2px' }}>
                                        <Label className="heading-color f-w-900 text-left">MMP %</Label>
                                    </Col>
                                    <Col className="responsive-col-expense" xs={12} style={{ width: '5%', paddingInline: '2px' }}>
                                    </Col> */}
                  </div>
                  <div className="container-fluid">
                    {Object.keys(clientFactFindData).map((parentCategory) => {
                      return (
                        <div key={parentCategory}>
                          <div className="d-flex align-items-center mt-4 mb-2">
                            <Col xs={12} className='d-flex'>
                              <H6 className="heading-color f-w-900 text-left">{parentCategory !== "Renting a Property" && parentCategory}</H6>
                            </Col>
                          </div>
                          {clientFactFindData[parentCategory].map((categoryName: string, index: number) => {
                            return (
                              <div key={index} className='d-flex item-center'>
                                <Col className="responsive-col-expense" xs={12} style={{ width: '20%' }}>
                                  <Label
                                    style={{ color: categoryName === "I am Renting A Property" ? 'blue' : '' }}
                                    className="mb-3"
                                  >
                                    {categoryName}
                                  </Label>
                                </Col>
                                <Col className="responsive-col-expense" xs={12} style={{ width: '13%', paddingInline: '2px' }}>
                                  <DollarInput
                                    label=""
                                    name={`${categoryName}-amount`}
                                    value={formData[`${categoryName}-amount`]}
                                    setValue={(name, value) => handleValueChange(`${categoryName}-amount`, value)}
                                    placeholder=""
                                    design="flex"
                                    limit={6}
                                  />
                                </Col>
                                <Col className="responsive-col-expense" xs={12} style={{ width: '13%', paddingInline: '2px' }}>
                                  <Dropdown
                                    label=""
                                    name={`${categoryName}-frequency`}
                                    value={formData[`${categoryName}-frequency`] || ''}
                                    options={splitDropdownValues(DropdownData ? DropdownData[11]?.dropDownValues : '')}
                                    setValue={(name, value) => handleValueChange(`${categoryName}-frequency`, value)}
                                  />
                                </Col>
                              </div>
                            );
                          })}
                        </div>
                      );
                    })}
                  </div>
                </Row>
              </table>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default Expenses;
